import React from "react";
import { Link } from "react-router-dom";
import { PageShell } from "../components/PageShell";

export default function PrivacyPage() {
  return (
    <PageShell title="Privacy-voorwaarden">
      <div data-testid="privacy-page" className="space-y-4 text-sm leading-relaxed text-slate-700">
        <h1 className="text-2xl font-semibold text-slate-900">Privacy-voorwaarden</h1>
        <p className="text-xs text-slate-500">Laatst bijgewerkt: 1 juni 2026 — versie v1</p>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Wat slaan we op</h2>
          <p>
            Wij verwerken de volgende gegevens van u:
          </p>
          <ul className="list-disc space-y-1 pl-5">
            <li>Naam, geboortedatum, contactgegevens (e-mail, telefoon, adres)</li>
            <li>Naam van uw werkgever (vanuit uw deelname aan het programma)</li>
            <li>Uw antwoorden op de vragenlijsten (nulmeting, zolen-wencontrole, vervolgmeting)</li>
            <li>Resultaten van de fysieke aanmeting op de aanmeetdag (voet-maten, pijn-plekken)</li>
            <li>Gegevens van uw geleverde steunzolen</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Waarom we het opslaan</h2>
          <p>
            Om u de juiste zolen te leveren, het traject te begeleiden en te beoordelen of het preventieprogramma uw klachten daadwerkelijk vermindert. Daarvoor vergelijken we uw nulmeting met de vervolgmeting na 12 weken.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Wat uw werkgever ziet</h2>
          <p>
            Uw werkgever ziet <span className="font-semibold">nooit</span> uw individuele antwoorden of naam. Uw werkgever ontvangt alleen geaggregeerde scores per groep van minimaal 5 werknemers. Bij kleinere groepen rapporteren we geen werkgever-cijfers.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Wie heeft toegang</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>De podotherapeut die aan u gekoppeld is</li>
            <li>De aanmeter die de fysieke meting uitvoert</li>
            <li>Programma-coördinator (Fulkra Works-admin) voor planning en levering</li>
          </ul>
          <p>Niemand anders dan deze rollen heeft toegang tot uw gegevens.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Hoe lang we bewaren</h2>
          <p>
            5 jaar na het einde van uw traject, voor onderzoeksdoeleinden. Daarna anonimiseren of verwijderen we de gegevens automatisch. U kunt op elk moment vragen uw gegevens eerder te verwijderen.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Uw rechten</h2>
          <p>
            U heeft op elk moment recht op:
          </p>
          <ul className="list-disc space-y-1 pl-5">
            <li>Inzage in uw gegevens</li>
            <li>Correctie van onjuiste gegevens</li>
            <li>Verwijdering van uw gegevens</li>
            <li>Bezwaar tegen verwerking</li>
            <li>Een kopie van uw gegevens in een gangbaar formaat</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Contact</h2>
          <p>
            Voor vragen of het uitoefenen van uw rechten:{" "}
            <a href="mailto:info@fulkraworks.nl" className="text-blue-600 underline">
              info@fulkraworks.nl
            </a>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-slate-900">Beveiliging</h2>
          <p>
            Uw gegevens staan op servers binnen de Europese Unie (Supabase, regio eu-west-1). Toegang is beveiligd met inloggegevens en twee-factor-authenticatie voor alle medewerkers met toegang.
          </p>
        </section>

        <div className="border-t border-slate-200 pt-4">
          <Link to="/" className="text-sm text-blue-600 underline">← Terug</Link>
        </div>
      </div>
    </PageShell>
  );
}
